import React from "react";
import AdminProfileContent from "../components/Admins/AdminProfileContent";
import "./AdminProfile.css";

const AdminProfile = () => {
  return (
    <div className="admin-profile-page">
      <AdminProfileContent />
    </div>
  );
};

export default AdminProfile;
